module.exports = __webpack_public_path__ + "static/media/reccurence-icon.1f98fc70.svg";